import { useState, useEffect } from 'react';
import { initGTM } from '../utils/gtm';
import { initPixel } from '../utils/metaPixel';

// localStorage is appropriate here — stores only a consent preference string.
// No PII is stored; this is standard practice for cookie consent banners.
const STORAGE_KEY = 'reload_cookie_consent';

export function useCookieConsent() {
  const [visible, setVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);

  // STORAGE_KEY is a module constant; localStorage and init fns are stable references.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      setVisible(true);
    } else if (saved === 'accepted') {
      initGTM();
      initPixel();
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    initGTM();
    initPixel(); // fires PageView internally — do not call trackPageView() again here
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(STORAGE_KEY, 'declined');
    setVisible(false);
  };

  return {
    visible,
    expanded, setExpanded,
    accept,
    decline,
  };
}
